<template>
  <div class="purchaseOrderLine--tab">
    <b-row class="grid-header">
      <b-col>
        <div class="pull-right tools">

        </div>
      </b-col>
    </b-row>
    <grid-component
        isResizable
        isReorderable
        :canEdit="checkClaim(CAN_EDIT_POS)"
        :canDelete="checkClaim(CAN_DELETE_POS)"
        :gridId="gridId"
        :itemData="itemData"
        :fields="fields"
        :navigationField="'purchaseOrderId'"
        @checkedItem="checkedRowItemIds=$event"
        :styleCustom="'height: 160px'"
      />
<!--    :onEdit="pushToDetails"-->
</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { GRID_ID } from '@/shared/constants';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import gridFields from './fields';

export default {
  components: {
    GridSettings,
    GridComponent
  },
  props: {
    salesOrderLineId: {
      type: [Number, String],
      default: 0
    },
    purchaseOrderLineId: {
      type: [Number, String],
      default: 0
    },
    gridId: {
      type: String,
      default: GRID_ID.ON_ORDER_LINES
    },
    partId: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      fields: gridFields,
      selectedRowItemId: 0,
      checkedRowItemIds: [],
      checkedRowItemsObjArr: [],
    };
  },
  computed: {
    //...mapGetters('purchaseorders', ['gridList',]), //commented by jitendra because in vcrma detail page POs tab doen't show po line list
    ...mapGetters('purchaseorders', ['purchaseOrderLines']),
    ...mapGetters('account', ['gridSettingsById']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    itemData() {
      if (this.purchaseOrderLines == undefined || !this.purchaseOrderLines.length) return [];
      return this.purchaseOrderLines.map((poline) => ({ ...poline, selected: poline.id === this.selectedRowItemId }));
    },
  },
  methods: {
    ...mapActions('purchaseorders', [
        'getOrdersBySalesOrderLine',
        'getOrdersByPurchaseOrderLine',
        'getByParts',
      ]),
    ...mapMutations('purchaseorders', ['setItem']),
    ...mapActions('account', ['saveGridSettings']),
    /*pushToDetails(row) {
      this.$router.push({
        name: 'purchaseorders.edit',
        params: { id: row.purchaseOrderId },
      });
    },*/
  },
  watch: {
    //commented by jitendra because in vcrma detail page POs tab doen't show po line list
    /*purchaseorders() {
      //This function sets the first row as the selected row
      if (this.purchaseorders.length > 0 && this.selectedRowItemId === 0) {
        this.selectedRowItemId = this.purchaseorders[0].id;
        const { id, detailsVisible } = this.purchaseorders[0];
      }
    },*/
    async purchaseOrderLineId() {
      this.setItem({ resource:'purchaseOrderLines', payload: [] });
      if (this.purchaseOrderLineId) {
        //console.log('this.purchaseOrderLineId', this.purchaseOrderLineId);
        this.getOrdersByPurchaseOrderLine(this.purchaseOrderLineId);
      }
    },
    async salesOrderLineId() {
      this.setItem({ resource:'purchaseOrderLines', payload: [] });
      if (this.salesOrderLineId) {
        //console.log('this.salesOrderLineId', this.salesOrderLineId);
        this.getOrdersBySalesOrderLine(this.salesOrderLineId);
      }
    },
    async partId() {
      this.setItem({ resource:'purchaseOrderLines', payload: [] });
      if (this.partId) {
        await this.getByParts(this.partId);
      }
    }
  },
  async mounted() {
    this.setItem({ resource:'purchaseOrderLines', payload: [] });
    if (this.partId) {
      await this.getByParts(this.partId);
    }
    if (this.purchaseOrderLineId) {
      //console.log('this.purchaseOrderLineId', this.purchaseOrderLineId);
      this.getOrdersByPurchaseOrderLine(this.purchaseOrderLineId);
    }
  },
  beforeDestroy() {
    //this.select({ id: null, isChecked: false });
  },
};
</script>

<style lang="scss" scoped>
.purchaseOrderLine--tab {
    .grid-header {
      margin-bottom: 5px;
  }
}
</style>
